import { createSlice } from '@reduxjs/toolkit'
const today = new Date().toISOString().split("T")[0];
export const counterSlice = createSlice({
    name: 'search',
    initialState: {
        adssearch: '',
        opssales: '',
        date: '',
        campcount: -1,
        clickcamp: -1,
        component_id: -1,
        regionlocation: { type: 'user_type', value: 0, user_type: 0 },
        network_ads_date: '',
        network_ad_type: 'All',
        network_ad_search: '',
        birdviewSource: 'All',
        birdviewSearch: "",
        birdviewDate: '',
        b2b_permissions: [],
        lineItemsFlag: false,
        LIstatus: -1,
        orderStatus:'all',
        showSideNav:true,
        selectedYear:new Date().getFullYear(),
        salesUsersList: [],
        sales_ops_order:{index:-1},
        new_user_type: 1,
        subordinates: [],
        birdViewAiFiters:{
            search : "",
            selectedLocation:[],
            dateRange:{
                startDate:today,
                endDate:today
            },
            adType:'finite',
            selectedBrandType:'',
            selectedNewspaper:[],
        },
        birdviewRejectFilters:{
            search : "",
            selectedLocation:[],
            dateRange:{
                startDate:today,
                endDate:today
            },
            adType:'finite',
            selectedBrandType:'',
            selectedNewspaper:[],
        }
    },    reducers: {
        Headersearch: (state, action) => {
            state.adssearch = action.payload
        },
        SetOpsSales: (state, action) => {
            state.opssales = action.payload
        },
        SetDate: (state, action) => {
            state.date = action.payload
        },
        SetCampCount: (state, action) => {
            state.campcount = action.payload
        },
        setSalesOpsOrder: (state, action) => {
            state.sales_ops_order = action.payload
        },
        SetClickCamp: (state, action) => {
            state.clickcamp = action.payload
        },
        SetComponentId: (state, action) => {
            state.component_id = action.payload
        },
        SetRegionLocation: (state, action) => {
            state.regionlocation = action.payload
        },
        SetNetworkAddate: (state, action) => {
            state.network_ads_date = action.payload
        },
        SetNetworkAdtype: (state, action) => {
            state.network_ad_type = action.payload
        },
        SetNetworkAdsearch: (state, action) => {
            state.network_ad_search = action.payload
        },
        SetBirdViewSource: (state, action) => {
            state.birdviewSource = action.payload
        },
        SetBirdViewSearch: (state, action) => {
            state.birdviewSearch = action.payload
        },
        SetBirdViewDate: (state, action) => {
            state.birdviewDate = action.payload
        },
        Setb2b_permissions: (state, action) => {
            state.b2b_permissions = action.payload
        },
        SetlineItemsFlag: (state, action) =>{
            state.lineItemsFlag = action.payload
        },
        SetLIstatus: (state, action) => {
            state.LIstatus = action.payload
        },
        SetorderStatus:(state, action) =>{
            state.orderStatus = action.payload
        },
        SetShowsideNav: (state, action) =>{
            state.showSideNav = action.payload
        },
        SetSelectedYear: (state, action) =>{
            state.selectedYear = action.payload
        },
        SetSalesUsersList: (state, action) => {
            state.salesUsersList = action.payload
        },
        setSalesTeam: (state, action) => {
            state.new_user_type = action.payload
        },
        setSubordinates : (state, action) => {
            state.subordinates = action.payload
        },
        SetBirdViewFilters: (state, action) => {
            state.birdViewAiFiters = action.payload
        },
        setBirdViewRejectFilters:(state, action)=>{
            state.birdviewRejectFilters = action.payload
        }
    }
})

// Action creators are generated for each case reducer function
export const { Headersearch, SetOpsSales, SetDate, SetCampCount, SetClickCamp, SetComponentId, SetRegionLocation, SetNetworkAddate, SetNetworkAdtype, SetNetworkAdsearch, SetBirdViewSearch, SetBirdViewSource, SetBirdViewDate, Setb2b_permissions, SetlineItemsFlag, SetLIstatus, SetShowsideNav, SetSelectedYear, SetSalesUsersList, SetorderStatus, setSalesOpsOrder, setSalesTeam, setSubordinates,SetBirdViewFilters,setBirdViewRejectFilters } = counterSlice.actions

export default counterSlice.reducer